/* FIKA B'LORE — Pincode gate (tiered)
 * Validates a 6-digit Indian pincode against three allow-lists
 * (close / medium / far), computes the next Wed/Fri delivery in IST,
 * and writes pincode + shipping_tier + delivery_day + delivery_date
 * to cart attributes via /cart/update.js.
 *
 * The same three lists are enforced by Shopify shipping zones at
 * checkout (defense-in-depth). This gate is UX, not security.
 */
(function () {
  if (window.__fikaPingateInit) return;
  window.__fikaPingateInit = true;

  var DAY_NAMES   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function nowIST() {
    var n = new Date();
    return new Date(n.getTime() + (n.getTimezoneOffset() * 60000) + (5.5 * 60 * 60000));
  }

  /* Mirrors get_next_delivery_day(now, cutoff_hour, delivery_weekdays) in main.py
   * for the Shopify storefront cadence:
   *   - Delivery days: Wed, Fri (JS getDay: Sun=0, so {3,5})
   *   - Cutoff:        8 pm IST by default
   *   - Before cutoff: earliest candidate = tomorrow
   *   - After cutoff:  earliest candidate = day after tomorrow
   *   - Roll forward until candidate weekday is allowed.
   * Ordering after Tue 8 pm rolls to Friday; after Thu 8 pm to next Wednesday.
   */
  function getNextDelivery(cutoffHour, deliveryDaysJsSet) {
    var ist = nowIST();
    var candidate = new Date(ist);
    candidate.setHours(0, 0, 0, 0);
    if (ist.getHours() < cutoffHour) {
      candidate.setDate(candidate.getDate() + 1);
    } else {
      candidate.setDate(candidate.getDate() + 2);
    }
    while (!deliveryDaysJsSet.has(candidate.getDay())) {
      candidate.setDate(candidate.getDate() + 1);
    }
    return { day: DAY_NAMES[candidate.getDay()], date: candidate };
  }

  function fmtDate(d) {
    return DAY_NAMES[d.getDay()] + ', ' + d.getDate() + ' ' + MONTH_NAMES[d.getMonth()];
  }
  function isoDate(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + dd;
  }
  function fillTpl(tpl, vars) {
    return tpl.replace(/%(\w+)%/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
  }
  function csvToSet(s) {
    return new Set((s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean));
  }
  function writeCartAttrs(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function (err) { console.warn('fika-pingate cart update failed', err); });
  }

  function setupGate(root) {
    if (root.__fikaPingateBound) return;
    root.__fikaPingateBound = true;

    var tiers = [
      { key: 'close',  label: 'close',  set: csvToSet(root.dataset.pinsClose),  rate: parseInt(root.dataset.rateClose  || '300', 10) },
      { key: 'medium', label: 'medium', set: csvToSet(root.dataset.pinsMedium), rate: parseInt(root.dataset.rateMedium || '400', 10) },
      { key: 'far',    label: 'far',    set: csvToSet(root.dataset.pinsFar),    rate: parseInt(root.dataset.rateFar    || '500', 10) },
    ];
    var cutoffHr   = parseInt(root.dataset.cutoffHour || '20', 10);
    var whatsapp   = root.dataset.whatsapp || '#';
    var successTpl = root.dataset.successTpl || '';
    var rejectTpl  = root.dataset.rejectTpl || '';
    /* JS getDay(): Sun=0, Mon=1, Tue=2, Wed=3, Thu=4, Fri=5, Sat=6.
       Shopify cadence delivers Wed, Fri => {3, 5}. */
    var deliveryDays = new Set([3, 5]);

    var input  = root.querySelector('#fika-pingate-input');
    var status = root.querySelector('#fika-pingate-status');
    var form   = root.querySelector('form');

    function lookupTier(pin) {
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].set.has(pin)) return tiers[i];
      }
      return null;
    }

    /* Restore from cart attribute if present. */
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var pin = cart && cart.attributes && cart.attributes.pincode;
      if (pin && /^[0-9]{6}$/.test(pin)) {
        input.value = pin;
        validate(pin, /* silent */ false);
      }
    }).catch(function () {});

    function validate(pin, silent) {
      if (!/^[0-9]{6}$/.test(pin)) {
        if (!silent) {
          status.innerHTML = '<span class="fika-pingate__status fika-pingate__status--error">Enter a 6-digit pincode.</span>';
        }
        return false;
      }
      var t = lookupTier(pin);
      if (!t) {
        var msg = fillTpl(rejectTpl, { pin: pin });
        status.innerHTML = '<span class="fika-pingate__status--reject">' + msg +
          ' <a href="' + whatsapp + '" target="_blank" rel="noopener">WhatsApp</a></span>';
        writeCartAttrs({ pincode: '', shipping_tier: '', delivery_day: '', delivery_date: '' });
        return false;
      }
      var nx = getNextDelivery(cutoffHr, deliveryDays);
      var msgOk = fillTpl(successTpl, {
        pin:  pin,
        tier: t.label,
        fee:  t.rate,
        day:  fmtDate(nx.date),
      });
      status.innerHTML = '<span class="fika-pingate__status--ok fika-pingate__status--' + t.key + '">' + msgOk + '</span>';
      writeCartAttrs({
        pincode:       pin,
        shipping_tier: t.key,
        delivery_day:  nx.day,
        delivery_date: isoDate(nx.date),
      });
      return true;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      validate((input.value || '').trim(), false);
    });

    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 6);
      if (input.value.length === 6) validate(input.value, false);
    });
  }

  function scan() {
    document.querySelectorAll('[data-fika-pingate]').forEach(setupGate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
